export const FAKE_IDENTITIES = [
    {
        cached: true,
        company_name: "Simonis - Runte",
        company_timezone: "Asia/Tokyo",
        email_address: "Ada_Erdman@gmail.com",
        first_name: "Mack",
        last_name: "Murazik",
        mimic_user: false,
        phone_number: "+10490528042",
        user_created_at: "2022-08-18T00:04:02.618Z",
        user_hash: "TS2AR7}8}}U^wFE?z[Al.Fg'e0^gHC.a",
        user_timezone: "Atlantic/Cape_Verde",
    },
    {
        cached: false,
        company_name: "Bayer, Russel and Prohaska",
        company_timezone: "Asia/Magadan",
        email_address: "Oral.Welch60@gmail.com",
        first_name: "Wanda",
        last_name: "Hegmann",
        mimic_user: false,
        phone_number: "+14336442112",
        user_created_at: "2022-08-18T00:05:28.357Z",
        user_hash: '0+}O.7;qE,7$L2oIO4"qO).)Sh}-&#$N',
        user_timezone: "Asia/Magadan",
    },
    {
        cached: true,
        company_name: "Ferry - Lowe",
        company_timezone: "Asia/Tokyo",
        email_address: "Providenci_Macejkovic55@yahoo.com",
        first_name: "Viva",
        last_name: "Rau",
        mimic_user: false,
        phone_number: "+15691249079",
        user_created_at: "2022-08-18T00:05:55.302Z",
        user_hash: "9s>b6dzC'\\?e`'1D%NK,rV]hYgL6Xq^K",
        user_timezone: "America/Juneau",
    },
    {
        cached: false,
        company_name: "Spinka and Sons",
        company_timezone: "Europe/Istanbul",
        email_address: "Madisen_Pollich8@gmail.com",
        first_name: "Lupe",
        last_name: "Kihn",
        mimic_user: false,
        phone_number: "+18309616252",
        user_created_at: "2022-08-18T00:06:12.401Z",
        user_hash: "sb?tCrj#s2Ww#genuQ.1UDwqUCMR6?zc",
        user_timezone: "America/La_Paz",
    },
    {
        cached: true,
        company_name: "Kuhn Inc",
        company_timezone: "Asia/Kathmandu",
        email_address: "Ward64@yahoo.com",
        first_name: "Vida",
        last_name: "Pollich",
        mimic_user: false,
        phone_number: "+14853214151",
        unique_identity: "Vida Pollich (0)",
        user_created_at: "2022-08-18T00:06:33.589Z",
        user_hash: "P3M{kD&rEgMJEP-nS?FMw#zl^jyq<|VG",
        user_timezone: "Asia/Dhaka",
    },
    {
        cached: false,
        company_name: "Doyle - Mills",
        company_timezone: "Asia/Seoul",
        email_address: "Kristin_Batz@gmail.com",
        first_name: "Betty",
        last_name: "Mohr",
        mimic_user: false,
        phone_number: "+14335119947",
        user_created_at: "2022-08-18T00:06:55.483Z",
        user_hash: 'o0`@zSb,Q#e:w!91$:UPR@FZ9yE^3"]-',
        user_name: "Betty Mohr",
        user_timezone: "Europe/Belgrade",
    },
    {
        cached: true,
        company_name: "Batz - Greenholt",
        company_timezone: "Pacific/Auckland",
        email_address: "Lorenza99@yahoo.com",
        first_name: "Maci",
        last_name: "Fadel",
        mimic_user: true,
        phone_number: "+18365184884",
        unique_identity: "Lorenza99@yahoo.com as Maci Fadel (0)",
        user_created_at: "2022-08-18T00:07:56.738Z",
        user_hash: '[pJ_pcDlrQ3"n//52$O@Fp[eY7u{V]7x',
        user_timezone: "Europe/Moscow",
    },
    {
        cached: true,
        company_name: "Schroeder - Luettgen",
        company_timezone: "Europe/Brussels",
        email_address: "Devon.Hand59@yahoo.com",
        first_name: "Modesta",
        last_name: "Kulas",
        mimic_user: true,
        phone_number: "+18875252818",
        user_created_at: "2022-08-18T00:08:33.364Z",
        user_hash: ':6{ASU<sAN"`n#F:(2&>OMW$%]jQ:1=X',
        user_timezone: "Europe/London",
    },
    {
        cached: false,
        company_name: "Reilly, Little and Altenwerth",
        company_timezone: "Pacific/Fiji",
        email_address: "Adriel73@yahoo.com",
        first_name: "Hassie",
        last_name: "Hamill",
        mimic_user: true,
        phone_number: "+11823346221",
        user_created_at: "2022-08-18T00:08:53.721Z",
        user_hash: "Dd.?KBnsSF/UnTk6$tc!YPwh>!|YO9i'",
        user_timezone: "Europe/Warsaw",
    },
    {
        cached: true,
        company_name: "Zulauf and Sons",
        company_timezone: "Asia/Kathmandu",
        email_address: "Sedrick_Feeney@gmail.com",
        first_name: "Keyon",
        last_name: "VonRueden",
        mimic_user: true,
        phone_number: "+11255733820",
        user_created_at: "2022-08-18T00:09:15.694Z",
        user_hash: "[a`1[[T[R5EW5MDlq_!o_/4u0,y8VRA,",
        user_timezone: "Africa/Nairobi",
    },
].map((identity) => ({
    ...identity,
    company_id: 0,
    user_id: 0,
    user_name: `${`${identity.first_name} ${identity.last_name}`}`,
    unique_identity: `${identity.mimic_user ? `${identity.email_address} as ` : ""}${`${identity.first_name} ${identity.last_name}`} (0)`,
}));
//# sourceMappingURL=identities.js.map